import React, { createContext, useContext, useState, useEffect } from 'react';
import { getCurrentUser } from 'aws-amplify/auth';
import { useNavigate, useLocation } from 'react-router-dom';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [currentUser, setCurrentUser] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  const resetAuth = () => {
    setIsAuthenticated(false);
    setCurrentUser(null);
    if (!location.pathname.match(/^\/(login|signup|verify-email|forgot-password|change-password)$/)) {
      navigate('/login');
    }
    setIsLoading(false);
  }

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const user = await getCurrentUser();
        setIsAuthenticated(true);
        setCurrentUser(user);
        setIsLoading(false);
      } catch (error) {
        resetAuth();
      }
    };

    checkAuth();
  }, [location.pathname, navigate]);

  const value = {
    isAuthenticated,
    isLoading,
    currentUser,
    resetAuth,
    setIsAuthenticated,
    setIsLoading,
    setCurrentUser
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}; 